<template>
    <div beginpage data-layout-type="regular" :data-layout-width="layout.LayoutWidth">
        <header :data-position="layout.HeaderAlignmentPublicName">
            <media
                v-if="layout.HeaderImagePath"
                data-logo
                :url="state.layout.HeaderImagePath"
                alt="Layout Logo"
                aria-hidden="true"
                type="Image"
            />
        </header>
        <languageswitcher v-if="state.languages !== undefined && state.languages.length > 1" />
        <main>
            <div data-main :data-text-position="layout.TextAlignmentPublicName">
                <p v-if="text" v-html="$sanitize(text)" id="begin-text"></p>
                <button
                    @click.prevent="userWantsToStart"
                    href
                    autofocus
                    id="login-link"
                    :value="linkText"
                    aria-labelledby="begin-text"
                    :disabled="state.global.showLoader"
                >{{$sanitize(linkText)}}</button>
            </div>
        </main>
        <footer v-if="layout.RemovePoweredBy !== true" data-crowdtech-logo>
             <a :href="state.surveyInfo.culture === `nl-NL` ? `https://welcome.crowdtech.com/pdc` : `https://welcome.crowdtech.com/pbc`" target="_blank">
                <media
                    :url="`${state.settings.assetPath}powered-by-crowdtech-logo-${constrastCheck}.svg`"
                    alt="Crowdtech logo"
                    type="Image"
                />
            </a>
        </footer>
    </div>
</template>

<script>
import media from "@/components/Media.vue";
import Vue from "vue";
import VueSanitize from "vue-sanitize";
import store from "@/store/store";
import methods from "@/global/methods.js";
import languageswitcher from "@/components/LanguageSwitcher.vue";

Vue.use(VueSanitize, store.state.global.allowedHtml);

export default {
    name: `beginpage-view`,
    components: {
        media,
        languageswitcher
    },
    computed: {
        linkText: function () {
            return this.$route.params.linkText;
        },
        text: function () {
            return this.$route.params.text;
        },
        state: function () {
            return this.$store.state;
        },
        layout: function () {
            return this.state.layout;
        },
        constrastCheck: function () {
            return methods.hexToRgb(this.layout.BackgroundColor);
        },
    },
    methods: {
        userWantsToStart: function () {
            this.$store.dispatch(`nextButtonClicked`, {
                nextButtonClicked: false,
                actionType: `Start`,
            });
        },
    },
    created() {
        this.$store.commit(`changeGlobal`, {
            variableName: `showLoader`,
            newValue: false,
        });
    },
};
</script>

<style lang="scss" scoped>
h2:empty {
    display: none;
}

[data-main] {
    button {
        background: transparent;
        border: 0;
        text-align: center;
        font-size: calc(var(--QuestionStyling-font-size) * 1px);
        color: var(--QuestionStyling-color);
        font-family: var(--QuestionStyling-font-family-public-name);
        text-decoration: underline;
        cursor: pointer;
    }

    p {
        margin: 0 0 25px 0;
    }

    &[data-text-position="Left"] {
        align-items: flex-start;
        text-align: left;
    }

    &[data-text-position="Right"] {
        align-items: flex-end;
        text-align: right;
    }

    &[data-text-position="Center"] {
        align-items: center;
        text-align: center;
    }
}

#begin-text {
    width: 100%;
}
</style>